module.exports = __webpack_public_path__ + "media/stylesheets/images/marker-icon-2x-grey-c978ff24f2bb4b7399a87011a32666f0.png";